module.exports = __webpack_public_path__ + "static/img/bgcode.a5035442.png";